/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import AppContext from 'context/Context';
import { isEmpty, get, forIn } from 'lodash';

const NavbarTopDropDownMenus = ({ getLocationAPI }) => {
  const { setConfig } = useContext(AppContext);
  const [locationData, setLocationData] = useState([]);

  useEffect(() => {
    getLocationAPI.request();
  }, []);

  useEffect(() => {
    if (!isEmpty(getLocationAPI.data)) {
      const responseData = get(getLocationAPI.data, 'results', {});
      const filterOptions = [];
      forIn(responseData, (value, key) => {
        filterOptions.push({ key, value });
      });
      setConfig('cluster', filterOptions[0].key);
      setLocationData(filterOptions);
    }
  }, [getLocationAPI.data]);

  const handleChange = ({ target }) => {
    setConfig('cluster', target.value);
  };

  if (isEmpty(locationData)) {
    return null;
  }

  return (
    <>
      <Form.Select name="cluster" onChange={handleChange}>
        {locationData.map(item => (
          <option key={item.key} value={item.key}>
            {item.value}
          </option>
        ))}
      </Form.Select>
    </>
  );
};

export default NavbarTopDropDownMenus;
